import {Checkbox, Divider, ListItemIcon, Menu, MenuItem, Popover, Radio, Typography, WithStyles, withStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import IconButton from "@components/common/iconButton/iconButton.component";
import * as UserActions from '@services/user/user.actions';
import {ICreateTodo, IEditTodo, IHideTodo, ITodo, RENEWAL, TODO_TITLE_MIN_LENGTH, TODO_TYPE} from '@app-types/websocket/todo.types';
import * as TodoActions from '@services/todos/todo.action';
import * as React from 'react';
import {connect} from 'react-redux';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import {IFamilyMember} from '@app-types/websocket/family.types';
import {FamilyMemberType} from '@services/family/family.constants';
import TranslateNew from '@translate/TranslateNew';
import Dialog from "@components/common/dialog/dialog.component";
import PersonIcon from "@material-ui/icons/PersonRounded";
import PeopleIcon from "@material-ui/icons/PeopleAltRounded";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import AddIcon from "@material-ui/icons/AddRounded";
import CloseIcon from "@material-ui/icons/CloseRounded";
import DateRangeIcon from "@material-ui/icons/DateRange";
import DescIcon from "@material-ui/icons/SubjectRounded";
import RepeatIcon from "@material-ui/icons/ReplayRounded";
import DeleteIcon from "@material-ui/icons/DeleteForeverRounded";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {styleColors} from 'src/main.style';
import VVDatePicker from '@components/common/timepicker/VVDatePicker';
import {EditTodoStyle as styles} from './EditTodo.style';


const tn: TranslateNew = TranslateNew.getInstance();




interface IProps extends WithStyles<typeof styles> {
  myAccountId: number;
  todo?: ITodo;
  type?: TODO_TYPE;
  scheduleParents?: number[];
  // Packing items can be tagged with one of these when there is more than one.
  scheduleChildren?: number[];
  scheduleId?: number;
  family: IFamilyMember[];
  showHelp: boolean;
  showHelpHandover: boolean;
  hideHelp: (topic: string) => void;
  closeContainer: () => void;
  editTodo: (data: IEditTodo) => void;
  hideTodo: (data: IHideTodo) => void;
  createTodo: (data: ICreateTodo) => void;
  suggestedTitle?: string;
}

interface INewTodoState {
  hasTime: boolean;
  visible: number[];
  title: string;
  description?: string;
  dueDate: Date;
  assigned: number[];
  type: TODO_TYPE;
  renewal?: RENEWAL;
  tagged: number | null;
  showConfirm: boolean;
  editDue:boolean;
  openMenu: TodoMenu | null;
}

type TodoMenu = 'TAGGED' | 'RENEWAL' | 'ASSIGNED' | 'VISIBLE';

class EditTodo extends React.Component<IProps, INewTodoState> {

  private dueRef: React.RefObject<HTMLButtonElement> = React.createRef();
  private taggedRef: React.RefObject<HTMLButtonElement> = React.createRef();
  private renewalRef: React.RefObject<HTMLButtonElement> = React.createRef();
  private assignedRef: React.RefObject<HTMLButtonElement> = React.createRef();
  private visibleRef: React.RefObject<HTMLButtonElement> = React.createRef();
  private descRef: React.RefObject<HTMLTextAreaElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    if (props.todo) {
      let dueDate: Date = new Date();
      if (props.todo.dueDate) {
        dueDate = new Date(props.todo.dueDate);
      }

      this.state = {
        hasTime: props.todo.dueDate ? true : false,
        title: props.todo.title,
        description: props.todo.description || "",
        dueDate,
        assigned: props.todo.assigned ? props.todo.assigned.slice() : [],
        visible: props.todo.visible ? props.todo.visible.slice() : [],
        type: props.todo.type,
        renewal: props.todo.renewal,
        tagged: props.todo.tagged !== undefined ? props.todo.tagged : null,
        showConfirm: false,
        editDue:false,
        openMenu: null,
      };
    } else {
      const visible: number[] = [];
      for (const mem of this.props.family) {
        if (mem.role === FamilyMemberType.PARENT
          || mem.role === FamilyMemberType.VIEWER
          || mem.role === FamilyMemberType.CHILD) {
          visible.push(mem.id);
        }
      }

      this.state = {
        hasTime: false,
        title: (props.suggestedTitle ? props.suggestedTitle : ""),
        description: undefined,
        dueDate: new Date(),
        assigned: (this.props.type && this.props.type === TODO_TYPE.HANDOVER) ? [] : [this.props.myAccountId],
        visible,
        type: this.props.type ? this.props.type : TODO_TYPE.NORMAL,
        renewal: (this.props.type && this.props.type === TODO_TYPE.HANDOVER) ? RENEWAL.DROPPING_OFF : undefined,
        tagged: null,
        showConfirm: false,
        editDue:false,
        openMenu: null,
      };
    }
  }

  public componentDidMount() {
    this.fitDescription();
  }

  public render() {
    const classes = this.props.classes;
    const {openMenu} = this.state;
    const canSave = this.state.title !== undefined && this.state.title.length >= TODO_TITLE_MIN_LENGTH;
    const showAssigned = this.state.type === undefined || this.state.type === TODO_TYPE.NORMAL
      || (this.state.type === TODO_TYPE.HANDOVER && !!this.state.renewal
        && (this.state.renewal === RENEWAL.NONE || this.state.renewal === RENEWAL.STATIC));
    const visibleChoices = this.props.family.filter((mem) => mem.role === FamilyMemberType.CHILD
      || mem.role === FamilyMemberType.PARENT || mem.role === FamilyMemberType.VIEWER);
    const closeMenu = () => this.setState({openMenu: null});
    // Packing items keep who checks them off together with how that is decided.
    const assignedRow = (
      <Button ref={this.assignedRef} classes={{root: classes.rowButton, label: classes.rowButtonLabel}}
        aria-haspopup="true" onClick={() => this.setState({openMenu: 'ASSIGNED'})}>
        <div className={classes.leftColumn}><PersonIcon className={classes.greyIcon}/></div>
        <div className={classes.rightColumn}>
          <div className={classes.fullwidth + " " + classes.peopleLabel}>
            <span>{tn.lang.todoAssigned}</span>
            <span className={classes.avatarStack}>{this.avatarStack(this.state.assigned)}</span>
          </div>
          <AddIcon className={classes.greyBackgroundIcon}/>
        </div>
      </Button>
    );

    return (<>
      <Dialog
        open={this.state.showConfirm}
        onClose={() => this.setState({showConfirm: false})}
        title={tn.lang.uConfirm}
        content={<Typography>{tn.lang.deleteTodoInfo}</Typography>}
        actions={
          <>
            <Button
              variant="contained"
              color="default"
              size="small"
              onClick={() => this.setState({showConfirm: false})}>{tn.lang.cancel}</Button>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={() => {
                this.hideAndNoRepeat();
                this.props.closeContainer();
              }}>{tn.lang.iConfirm}</Button>
          </>
        }
      />
      {/* Laid out like the event form: an icon column on the left and grey inputs in sections. */}
      <div className={classes.pane}>
        <div className={classes.section}>
          <div className={classes.row}>
            <div className={classes.leftColumn}>
              {this.showTagged() && (
                <IconButton ref={this.taggedRef} style={{padding: 2}} aria-label={tn.lang.packingTaggedChild}
                  aria-haspopup="true" onClick={() => this.setState({openMenu: 'TAGGED'})}>
                  {this.taggedIcon(this.state.tagged)}
                </IconButton>
              )}
            </div>
            <div className={classes.rightColumn}>
              <input
                id="todo-title"
                type="text"
                value={this.state.title}
                spellCheck={true}
                maxLength={28}
                onChange={this.handleUpdateTitle}
                className={classes.greyInput + " " + classes.fullwidthInput}
                placeholder={tn.lang.labelTitle}
                aria-label={tn.lang.labelTitle}/>
            </div>
          </div>
        </div>
        {this.state.type === TODO_TYPE.HANDOVER && (
          <div className={classes.section}>
            <Button classes={{root: classes.rowButton, label: classes.rowButtonLabel}} tabIndex={-1}
              onClick={() => this.setState({openMenu: 'RENEWAL'})}>
              <div className={classes.leftColumn}><RepeatIcon className={classes.greyIcon}/></div>
              <div className={classes.rightColumn}>
                <div className={classes.fullwidth}>{tn.lang.todoResponsibleForCheckingOff}</div>
              </div>
            </Button>
            <div className={classes.row}>
              <div className={classes.leftColumn}/>
              <div className={classes.rightColumn}>
                <Button ref={this.renewalRef} classes={{root: classes.greyField, label: classes.greyFieldLabel}}
                  aria-haspopup="true" onClick={() => this.setState({openMenu: 'RENEWAL'})}>
                  <span>{this.renewalName(this.state.renewal || RENEWAL.NONE)}</span>
                  <ArrowDropDownIcon className={classes.greyIcon}/>
                </Button>
              </div>
            </div>
            {showAssigned && assignedRow}
          </div>
        )}
        <div className={classes.section}>
          {/* The whole row opens the menu, avatars included. */}
          {showAssigned && this.state.type !== TODO_TYPE.HANDOVER && assignedRow}
          <Button ref={this.visibleRef} classes={{root: classes.rowButton, label: classes.rowButtonLabel}}
            aria-haspopup="true" onClick={() => this.setState({openMenu: 'VISIBLE'})}>
            <div className={classes.leftColumn}><PeopleIcon className={classes.greyIcon}/></div>
            <div className={classes.rightColumn}>
              <div className={classes.fullwidth + " " + classes.peopleLabel}>
                <span>{tn.lang.todoVisibleTooltip}</span>
                <span className={classes.avatarStack}>{this.avatarStack(this.state.visible)}</span>
              </div>
              <AddIcon className={classes.greyBackgroundIcon}/>
            </div>
          </Button>
        </div>
        {this.state.type !== TODO_TYPE.HANDOVER && (
          <div className={classes.section}>
            {this.state.hasTime ? (
              <div className={classes.row}>
                <div className={classes.leftColumn}><DateRangeIcon className={classes.greyIcon}/></div>
                <div className={classes.rightColumn}>
                  <div className={classes.fullwidth}>{tn.lang.addDueDate}</div>
                  <Button ref={this.dueRef} classes={{root: classes.greyField, label: classes.greyFieldLabel}}
                    style={{flex: 'none'}} onClick={() => this.setState({editDue: true})}>
                    {tn.formatDateMonthShort(this.state.dueDate)}
                  </Button>
                  <IconButton style={{padding: 2, marginLeft: 4}} aria-label={tn.lang.delete}
                    onClick={() => this.addTime(false)}>
                    <CloseIcon className={classes.greyIcon}/>
                  </IconButton>
                </div>
              </div>
            ) : (
              <Button classes={{root: classes.rowButton, label: classes.rowButtonLabel}} onClick={() => this.addTime(true)}>
                <div className={classes.leftColumn}><DateRangeIcon className={classes.greyIcon}/></div>
                <div className={classes.rightColumn}>
                  <div className={classes.fullwidth}>{tn.lang.addDueDate}</div>
                  <AddIcon className={classes.greyBackgroundIcon}/>
                </div>
              </Button>
            )}
          </div>
        )}
        {/* Packing items get a description once they exist: they are added from a single title row. */}
        {this.showDescription() && (
          <div className={classes.section} style={{borderBottom: '0px'}}>
            <div className={classes.row} style={{maxHeight: 'unset'}}>
              <div className={classes.leftColumn} style={{alignSelf: 'flex-start', paddingTop: '2px'}}>
                <DescIcon className={classes.greyIcon}/>
              </div>
              <div className={classes.rightColumn}>
                <textarea
                  ref={this.descRef}
                  id="todo-description"
                  rows={2}
                  spellCheck={true}
                  value={this.state.description || ""}
                  onChange={this.handleUpdateDesc}
                  className={classes.greyInput + " " + classes.fullwidthInput}
                  style={{lineHeight: '20px', resize: 'none'}}
                  placeholder={tn.lang.eventDescriptionOptional}
                  aria-label={tn.lang.eventDescriptionOptional}/>
              </div>
            </div>
          </div>
        )}
        <div className={classes.actionsRow}>
          {this.props.todo && this.state.type === TODO_TYPE.HANDOVER && (
            <IconButton style={{padding: '8px 4px'}} aria-label={tn.lang.delete} disabled={!canSave}
              onClick={() => this.setState({showConfirm: true})}>
              <DeleteIcon style={{fontSize: '30px'}}/>
            </IconButton>
          )}
          <Button variant="outlined" classes={{outlined: classes.buttonOutlinedLarge}}
            onClick={() => this.props.closeContainer()}>
            {tn.lang.cancel}
          </Button>
          <Button variant="contained" color="primary" classes={{contained: classes.buttonContainedLarge}}
            disabled={!canSave}
            onClick={() => {
              this.handleSend();
              this.props.closeContainer();
            }}>
            {this.props.todo
              ? tn.lang.save
              : (this.state.type === TODO_TYPE.HANDOVER ? tn.lang.addTodoThing : tn.lang.addTodo)
            }
          </Button>
        </div>
      </div>

      <Popover
        disableScrollLock={true}
        anchorEl={this.dueRef.current}
        onClose={() => this.setState({editDue: false})}
        open={this.state.editDue}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        transformOrigin={{vertical: 'top', horizontal: 'center'}}
      >
        <VVDatePicker
          open={this.state.editDue}
          date={this.state.dueDate}
          setDate={(date: Date) => {
            const newTime = new Date(date);
            newTime.setMinutes(0);
            newTime.setHours(12);
            this.setState({dueDate: newTime});
          }}
        />
      </Popover>

      <Menu anchorEl={this.taggedRef.current} open={openMenu === 'TAGGED'} onClose={closeMenu}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}>
        {[null, ...(this.props.scheduleChildren || [])].map((child: number | null) =>
          <MenuItem key={child === null ? 'general' : child}
            onClick={() => this.setState({tagged: child, openMenu: null})}>
            <ListItemIcon>
              <Radio edge="start" checked={this.state.tagged === child} tabIndex={-1} disableRipple={true}/>
            </ListItemIcon>
            <span className={classes.menuPerson}>
              {this.taggedIcon(child)}
              {child === null ? tn.lang.packingGeneral : tn.familyMemberName(child, this.props.family)}
            </span>
          </MenuItem>
        )}
      </Menu>

      <Menu anchorEl={this.renewalRef.current} open={openMenu === 'RENEWAL'} onClose={closeMenu}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}>
        {[RENEWAL.DROPPING_OFF, RENEWAL.PICKING_UP, RENEWAL.STATIC, RENEWAL.NONE].map((renewal: RENEWAL) =>
          <MenuItem key={renewal} onClick={() => this.selectRenewal(renewal)}>
            <ListItemIcon>
              <Radio edge="start" checked={(this.state.renewal || RENEWAL.NONE) === renewal} tabIndex={-1}
                disableRipple={true}/>
            </ListItemIcon>
            {this.renewalName(renewal)}
          </MenuItem>
        )}
      </Menu>

      {this.peopleMenu('ASSIGNED', this.assignedRef, this.props.family, this.state.assigned, this.selectAssignee)}
      {this.peopleMenu('VISIBLE', this.visibleRef, visibleChoices, this.state.visible, this.selectVisibility)}
    </>);

  }

  private peopleMenu = (menu: TodoMenu, anchor: React.RefObject<HTMLButtonElement>, people: IFamilyMember[],
                        inList: number[], toggle: (person: IFamilyMember) => void) => (
    <Menu anchorEl={anchor.current} open={this.state.openMenu === menu} onClose={() => this.setState({openMenu: null})}
      getContentAnchorEl={null} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}>
      {people.map((person: IFamilyMember) =>
        <MenuItem key={person.id} onClick={() => toggle(person)}>
          <ListItemIcon>
            <Checkbox edge="start" checked={inList.indexOf(person.id) > -1} tabIndex={-1} disableRipple={true}/>
          </ListItemIcon>
          <span className={this.props.classes.menuPerson}>
            <ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar ? person.avatarURL : undefined}
              imgName={person.avatar} style={{width: '24px', height: '24px'}} color={person.color}/>
            {person.firstName}
          </span>
        </MenuItem>
      )}
      <Divider/>
      <MenuItem onClick={() => this.setState({openMenu: null})}>{tn.lang.close}</MenuItem>
    </Menu>
  );

  // Overlapping small avatars, as on the event form.
  private avatarStack = (ids: number[]) => ids.map((id: number, index: number) => {
    const person = this.props.family.find((mem: IFamilyMember) => mem.id === id);
    return person ? (
      <ImgAvatar key={id} altText={person.firstName} imgUrl={person.imageAvatar ? person.avatarURL : undefined}
        imgName={person.avatar} color={person.color}
        style={{width: '20px', height: '20px', border: `1px solid ${styleColors.white}`, marginLeft: index > 0 ? -10 : 0}}/>
    ) : null;
  });

  private renewalName = (renewal: RENEWAL) => {
    switch (renewal) {
      case RENEWAL.DROPPING_OFF:
        return tn.lang.todoRenewalDropOff;
      case RENEWAL.PICKING_UP:
        return tn.lang.todoRenewalPickUp;
      case RENEWAL.STATIC:
        return tn.lang.todoRenewalStatic;
      default:
        return tn.lang.todoRenewalOnce;
    }
  };

  private taggedIcon = (child: number | null) => {
    const member = child === null ? undefined : this.props.family.find((mem: IFamilyMember) => mem.id === child);
    if (!member) {
      return <PeopleOutlineIcon className={this.props.classes.greyIcon} style={{width: 24, height: 24}} />;
    }
    return <ImgAvatar altText={member.firstName} color={member.color} imgName={member.avatar}
      imgUrl={member.imageAvatar ? member.avatarURL : undefined} style={{width: 24, height: 24}} />;
  };

  private showDescription = () => this.state.type !== TODO_TYPE.HANDOVER || !!this.props.todo;

  private showTagged = () => this.state.type === TODO_TYPE.HANDOVER
    && !!this.props.scheduleChildren && this.props.scheduleChildren.length > 1;

  private selectRenewal = (renewal: RENEWAL) => {
    const visible = this.state.visible.slice();
    if (renewal === RENEWAL.DROPPING_OFF || renewal === RENEWAL.PICKING_UP) {
      if (this.props.scheduleParents) {
        for (const parent of this.props.scheduleParents) {
          if (this.state.visible.indexOf(parent) === -1) {
            visible.push(parent);
          }
        }
      }
    } else {
      for (const person of this.state.assigned) {
        if (this.state.visible.indexOf(person) === -1) {
          visible.push(person);
        }
      }

    }
    this.setState({renewal, visible, openMenu: null});

  };

  private hideAndNoRepeat = () => {
    if (this.props.todo) {
      const editTodo: IEditTodo = {
        id: this.props.todo.id,
        title: this.state.title,
        description: this.state.description,
        assigned: this.state.assigned,
        visible: this.state.visible,
        renewal: RENEWAL.NONE,
      };

      this.props.editTodo(editTodo);

      const hideTodo: IHideTodo = {
        id: this.props.todo.id
      };

      this.props.hideTodo(hideTodo);
    }
  };

  private handleSend = () => {

    let dueDate;

    if (this.state.hasTime) {
      dueDate = new Date(this.state.dueDate);
      dueDate.setHours(12);
    }

    if (this.props.todo) {
      const editTodo: IEditTodo = {
        id: this.props.todo.id,
        dueDate: dueDate ? dueDate.getTime() : undefined,
        title: this.state.title,
        description: this.state.description?this.state.description:"",
        assigned: this.state.assigned,
        visible: this.state.visible,
        renewal: this.state.renewal,
      };
      // Only sent where it can be picked, so the tag is kept everywhere else.
      if (this.showTagged()) {
        editTodo.tagged = this.state.tagged;
      }

      this.props.editTodo(editTodo);
    } else {
      const newTodo: ICreateTodo = {
        dueDate: dueDate ? dueDate.getTime() : undefined,
        title: this.state.title,
        description: this.state.description?this.state.description:"",
        assigned: this.state.assigned,
        visible: this.state.visible,
        renewal: this.state.renewal,
        type: this.state.type,
        scheduleId: this.props.scheduleId,
      };
      if (this.showTagged() && this.state.tagged !== null) {
        newTodo.tagged = this.state.tagged;
      }

      this.props.createTodo(newTodo);

    }

  };
  private handleUpdateDesc = (event: any) => {
    let text: string = event.target.value;
    if (text.length > 4900) {
      text = text.substr(0, 4900);
    }
    this.setState({description: text}, this.fitDescription);
  };

  // The description grows with its text, like on the event form.
  private fitDescription = () => {
    const area = this.descRef.current;
    if (area) {
      area.style.height = 'auto';
      area.style.height = area.scrollHeight + 'px';
    }
  };

  private handleUpdateTitle = (event: any) => {
    let text: string = event.target.value;
    if (text.length > 100) {
      text = text.substr(0, 100);
    }
    this.setState({title: text});
  };

  private handleUpdateDueDay = (date: Date) => {
    this.setState({dueDate: date});
  };

  private addTime = (showTime: boolean) => {
    this.setState({hasTime: showTime});
  };

  private formatDate = (date: Date) => {
    const year = date.getFullYear();
    let day = '' + date.getDate();
    let month = '' + (date.getMonth() + 1);

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  };

  private selectAssignee = (member: IFamilyMember) => {
    const assigned = this.state.assigned.slice();
    const visible = this.state.visible.slice();
    if (assigned.indexOf(member.id) > -1) {
      assigned.splice(assigned.indexOf(member.id), 1);
    } else {
      assigned.push(member.id);
    }
    if (visible.indexOf(member.id) === -1) {
      visible.push(member.id);
    }
    this.setState({assigned, visible});
  };

  private selectVisibility = (member: IFamilyMember) => {
    const visible = this.state.visible.slice();
    if (visible.indexOf(member.id) > -1) {
      if (this.state.assigned.indexOf(member.id) > -1) {
        return;
      }
      if (member.id === this.props.myAccountId) {
        return;
      }
      if (TODO_TYPE.HANDOVER === this.state.type && this.props.scheduleParents) {
        if (this.state.renewal
          && (this.state.renewal === RENEWAL.DROPPING_OFF || this.state.renewal === RENEWAL.PICKING_UP)
          && this.props.scheduleParents.indexOf(member.id) > -1) {
          return;
        }
      }
      visible.splice(visible.indexOf(member.id), 1);
    } else {
      visible.push(member.id);
    }
    this.setState({visible});
  };
}

function mapStateToProp(state: any) {
  const showHelp = state.user.help.createTodo;
  const showHelpHandover = state.user.help.createHandover;
  return {
    showHelp,
    showHelpHandover,
    family: state.family.family.filter((member: IFamilyMember) => member.role === FamilyMemberType.CHILD
      || member.role === FamilyMemberType.PARENT || member.role === FamilyMemberType.VIEWER),
    myAccountId: state.user.session.data.id
  };
}

const mapDispatchToProps = {
  editTodo: TodoActions.editTodo,
  createTodo: TodoActions.createTodo,
  hideTodo: TodoActions.hideTodo,
  hideHelp: UserActions.seenHelp
};

export default connect(mapStateToProp, mapDispatchToProps)(withStyles(styles)(EditTodo));



// WEBPACK FOOTER //
// ./src/components/todo/EditTodo.tsx